import { useRef } from "react";
import Slider from "react-slick";
import PropTypes from "prop-types";
// material
import { useTheme, styled } from "@mui/material/styles";
import { Box, Card, Typography, CardContent } from "@mui/material";
// utils
import { CarouselControlsPagingBelow } from "../carousel/controls";

// ----------------------------------------------------------------------

const RootStyle = styled("div")(({ theme }) => ({
  overflow: "hidden",
  position: "relative",
  "&:before, &:after": {
    top: 0,
    left: 0,
    zIndex: 8,
    width: 48,
    content: "''",
    height: "100%",
    display: "none",
    position: "absolute",
    [theme.breakpoints.up(480)]: {
      display: "block",
    },
  },
  "&:after": {
    right: 0,
    left: "auto",
    transform: "scaleX(-1)",
  },
  "& .slick-track": {
    display: "inline-flex",
  },
  "& .slick-arrow": {
    display: "none !important",
  },
}));

// ----------------------------------------------------------------------

CarouselItem.propTypes = {
  item: PropTypes.object,
};

function CarouselItem({ item }) {
  return (
    <Card sx={{ mx: 2, mb: 3, minHeight: 350 }}>
      <CardContent>
        <Box
          component="img"
          loading='lazy'
          alt={item.Alt}
          src={item.Imagen_Persona}
          width={100}
          height={100}
          border="solid"
          borderWidth="1px"
          borderColor="primary.main"
          borderRadius={50}
          display="block"
          mx="auto"
          mb={2}
          sx={{
            objectFit: 'cover'
          }}
        />
        <Typography variant="h6" align="center">
          {item.Titulo}
        </Typography>
        <Box textAlign="center" mb={1}>
          <Typography variant="caption" color="primary.dark">
            {item.Nombre_Persona}
          </Typography>
        </Box>

        <Typography variant="body1" align="center">
          {item.Testimonio_Persona}
        </Typography>
      </CardContent>
    </Card>
  );
}

CarouselCenterMode.propTypes = {
  arr: PropTypes.array,
};

export default function CarouselCenterMode({arr}) {
  const carouselRef = useRef();
  const theme = useTheme();

  const settings = {
    dots: true,
    slidesToShow: 2,
    infinite: false,
    rtl: Boolean(theme.direction === "rtl"),
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 600,
        settings: { slidesToShow: 1 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1, centerPadding: "0" },
      },
    ],
    ...CarouselControlsPagingBelow({
      sx: { mt: 3 },
    }),
  };

  return (
    <RootStyle>
      <Slider ref={carouselRef} {...settings}>
        {arr.map((item) => (
          <CarouselItem key={item._id} item={item} />
        ))}
      </Slider>
    </RootStyle>
  );
}
